import React from "react";
import { useAppSelector } from "../../../../redux/hook";
import ValidateCommand from "./ValidateCommand"; // parcours "basique" (produit uniquement)
import ValidateService from "./ValidateService"; // parcours "long" (service, ou produit + service)

/**
 * Détermine si un item du panier est un service, à partir du champ
 * `itemType` défini dans CartItemType (cart.slice.ts) : "produit" | "service".
 *
 * Le champ étant optionnel (`itemType?`), les items déjà en panier sans ce
 * champ sont considérés comme des "produit" (comportement historique).
 */
const isServiceItem = (item) => item?.itemType === "service";

function ValidatePanier() {
  const { cartItems } = useAppSelector((state) => state.cart);

  const hasService = cartItems?.some(isServiceItem);

  // Règles demandées :
  // - uniquement produit(s)            -> formulaire basique (ValidateCommand)
  // - uniquement service(s)            -> formulaire long (ValidateService)
  // - mélange produit(s) + service(s)  -> formulaire long (ValidateService)
  if (hasService) {
    return <ValidateService />;
  }

  return <ValidateCommand />;
}

export default ValidatePanier;